export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Recibís acceso inmediato después de la compra. Todos los PDFs están listos para descargar y usar. Podés imprimirlos, guardarlos en tu móvil o consultarlos desde cualquier dispositivo.',
  },
  {
    question: '¿Es para entrenadores experimentados solamente?',
    answer:
      'No. Si estás empezando, las progresiones te dan la ruta técnica que todavía no tenés armada. Si ya tenés años en la pista, el sistema te ahorra las horas de planificación y te da variedad para todo el año.',
  },
  {
    question: '¿Funciona en toda América Latina y España?',
    answer:
      'Sí. El material está 100% en español neutro, con distancias en metros y referencias válidas para cualquier pista. El pago se procesa en tu moneda local.',
  },
  {
    question: '¿Puedo editar y personalizar los PDFs?',
    answer:
      'Los PDFs están pensados para imprimir y usar tal cual en la pista, con espacio para tus anotaciones. Podés adaptar cualquier sesión a tu grupo: cada volumen incluye las variantes por nivel para hacerlo.',
  },
  {
    question: '¿Es solo para atletismo o incluye otros deportes?',
    answer:
      'Está construido específicamente para atletismo: velocidad, vallas, relevos, medio fondo, fondo, marcha, saltos y lanzamientos. Muchos entrenadores usan los bloques de velocidad y fuerza en otros deportes, pero el sistema es de pista y campo.',
  },
  {
    question: '¿Cómo funciona la garantía de 7 días?',
    answer:
      'Tenés 7 días para verificar que recibiste los 6 volúmenes y los 5 bonos detallados en esta página. Si algún archivo está incompleto, tiene problemas de acceso o el contenido no corresponde con lo descrito, escribinos: lo revisamos y, si no podemos solucionarlo, te devolvemos el 100% de tu compra.',
  },
]
